export const COLORS = ["#7950F2", "#15AABF", "#40C057", "#FA5252", "#ffa051"];
export const DEFAULT_HIGHLIGHT_COLOR = COLORS[4];

export const GET_COLOR = (num: number) => {
	return COLORS[num % COLORS.length];
};
